import stationDataConfigApi from '@/api/config/stationDataConfig'
import { queryKeys } from '@/constant/common'
import { useQuery } from '@tanstack/react-query'

function useStationLineUnitControl(
  interfaceId: number,
  addressLineUnit: number,
  twiId?: number,
  options?: any,
) {
  return useQuery(
    [queryKeys.lineUnitControl, addressLineUnit, interfaceId],
    async () => {
      if (!interfaceId || !addressLineUnit) return null
      const { data } = await stationDataConfigApi.getStationLineUnitControl(
        interfaceId,
        addressLineUnit,
        twiId,
      )
      if (!data) return null

      return data
    },
    {
      cacheTime: 0,
      enabled: false,
      ...(options && options),
    },
  )
}

export default useStationLineUnitControl
